var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.itemInfo || _vm.skeletonHint === 'item')?_c('nft-item',_vm._b({on:{"loadNext":_vm.loadNext}},'nft-item',_vm.itemInfo,false)):(_vm.collectionInfo || _vm.skeletonHint === 'collection' || !_vm.skeletonHint)?_c('nft-collection',_vm._b({attrs:{"address":_vm.address}},'nft-collection',_vm.collectionInfo,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }